(() => {
  if (customElements.get('quantity-input')) {
    return;
  }

  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');

      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.update.bind(this))
      );
    }

    update(e) {
      if (e.target.name === 'plus') {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  customElements.define('quantity-input', QuantityInput);
})();
